/**
 * Row compatibility component for react-bootstrap v2 migration.
 * Bootstrap 5 uses flexbox layout, Bootstrap 3 used float-based layout.
 *
 * This component restores Bootstrap 3's row behavior:
 * - display: block (not flex)
 * - 16px negative margins on each side
 * - clearfix for floating columns
 */
import Row from "react-bootstrap/Row"
import styled from "styled-components"

import {spacingCss, SpacingProps} from "../global/css"

export const CompatRow = styled(Row)<SpacingProps>`
  /* Restore Bootstrap 3 behavior */
  display: block;
  margin-right: -16px;
  margin-left: -16px;
  flex-wrap: unset;
  margin-top: unset;

  /* Clearfix */

  &::before,
  &::after {
    display: table;
    content: " ";
  }

  &::after {
    clear: both;
  }

  /* Remove B5's row > * styles from direct children */

  > * {
    flex-shrink: unset !important;
    max-width: unset !important;
    margin-top: unset !important;
  }

  ${spacingCss}
`
